import React from 'react';
import { hydrate, render } from 'react-dom';
import { unregister } from './registerServiceWorker';

import App from './App';

const rootEl = document.getElementById('root');
const firstRun = !rootEl.hasChildNodes();

if (firstRun) {
  render(<App />, rootEl);
} else {
  hydrate(<App />, rootEl);
}

unregister();
